import { setTeamsSdk, teamsSdk } from '../teams-sdk/teamsSdk';

export const initializeTeamsSdk = async () => {
  try {
    await setTeamsSdk();
    teamsSdk.initialize();
    console.log(
      '[initialize-teams-sdk.initializeTeamsSdk] Initializing Microsoft Teams SDK'
    );
  } catch (error) {
    throw new Error('error: ' + error.message());
  }
};
